const Box = ({ children, ...rest }: any) => {
  return (
    <div
      className={`bg-white rounded-[10px] shadow p-6 mb-5 ${rest.className}`}
    >
      {children}
    </div>
  );
};
export default Box;
